<template>
    <div>
        <div class="row mx-0">
            <div class="col-sm-12 col-md-3 px-0">
                <Header
                :name="user.name"
                />
                <div class="center pb-4">
                    <b-btn v-b-modal.modal-logout variant="outline-secondary" class="logout">Cerrar Sesión</b-btn>
                    <b-modal id="modal-logout" centered hide-footer hide-header 
                    body-class="p-0" dialog-class="px-5" content-class='border-0'>
                        <div class="d-block text-center">
                            <img :src="closeIcon" class="icon3 pt-5"><br>
                            <p class="modalHeader pt-3">Cerrar sesión</p>
                            <p class="modalBody">¿Estás seguro que deseas salir?</p>
                        </div>
                        <div class="wrapper center">
                            <b-button class="one mt-3 py-3 btnleft" @click="$bvModal.hide('modal-logout')">Cancelar</b-button>
                            <b-button class="two mt-3 btnright" @click="logout()">Confirmar</b-button>
                        </div>
                    </b-modal>
                </div>

                <SideMenu/>
            </div>
            <div class="col-sm-12 col-md-9 bg-gris">
                <b-row class="py-4 px-5">
                    <b-col cols="12" md="5">
                        <h2 v-if="!historyOption" class="blueText">{{cityName}}</h2>
                         <h2 v-else class="blueText">CSV Plantas</h2>
                    </b-col>
                    <b-col cols="12" md="7">
                        <div class="btn-toolbar">

                             <div v-if="user.num ==15177117 || user.num == 10109 || user.num == 10291 || user.num == 501161 || user.num == 990012" class="btn-to-plantas">
                                <b-btn variant="outline-secondary" @click="setHistoryOptionCsv(!historyOption)" >CSV Plantas </b-btn>                        
                            </div>


                            <div v-if="user.num ==15177117 || user.num == 10109 || user.num == 10291 || user.num == 501161 || user.num == 990012" class="btn-to-query">
                                <b-btn variant="outline-secondary" @click="toQuery()" >Actualizar Query</b-btn>                        
                            </div>

                           
                            <CSV v-if="hora() =='yes'"
                            :reporte="reportInfo"
                            />                                
                            <Dropdown
                            :departments="dep.deptos"
                            />     
                        </div>                                          
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col cols="12" lg="7" >
                        <div v-if="historyOption==false">
                            <div v-if="isLoading" class="center pt-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <FormInfoBase v-else
                        :equipo="bd.equipo_convertido"
                        :extra="bd.$_extra_m3"
                        :diasS="bd.dias_sucios"
                        :base0="String(bd.base0)"
                        :bono="depto.bono_persona"
                        :asistencia="depto.asistencia"
                        :statusDepto="depto.statusDepto"
                        :monto="depto.pago_base"
                        :prod="bd.prod"
                        :areas="bd.areas"
                        :montos_areas="bd.montos_recibidos_area" 
                        :lastweek="depto.lastWeek"
                        :historial="depto.historial"
                        :colaboradores="depto.colaboradores"
                        />
                        </div>
                        <div v-else>
                            <Plantas/>
                        </div>
                    </b-col>
                    <b-col cols="12" lg="5" class="px-0">
                        <Graphics/>
                        <!-- <div>
                            <calculadora/>
                        </div>

                        -->
                       
                    </b-col>
                </b-row>
                
            </div>
        </div>
        
    </div>
</template>


<script>
import Header from '../components/Header';
import SideMenu from '../components/SideMenu';
import FormInfoBase from '../components/FormInfoBase';
import Graphics from '../components/Graphics';
import Dropdown from '../components/Dropdown';
import CSV from '../components/CSV';
import i_logout from '../assets/iconocerrar.png'
import calculadora from '../components/calculadora'
import moment from 'moment'
import Plantas from './csvPlantas.vue'

import {mapActions} from 'vuex';
export default {
    name: 'Dashboard',
    components: {
        Header,
        SideMenu,
        FormInfoBase,
        Graphics,
        Dropdown,
        CSV,
        calculadora,
        Plantas
    },
    data() {
        return {
            closeIcon: i_logout,
            csvPlantas: false
        }
    },
    async beforeMount() {
        let token = await this.$store.dispatch("userService/getToken");
        this.$store.dispatch("userService/decode", token);
    }, 
    created() {
        // obtener el ultimo departamento y ciudad guardado.
        let depto = this.$store.getters["plants/getHistoryDepto"]
        let city = this.$store.getters["plants/getHistoryCity"]
        let linkcity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
        let linkdepto = depto.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");

        /*
        console.log("depto:"+depto)
        console.log("city:"+city)
        console.log("linkdepto:"+linkdepto)
        console.log("linkcity:"+linkcity)
        */        
        this.$store.dispatch("plants/getBDInfo", {// info del model (Bd)
            department: linkdepto,
            city: linkcity
        });
        this.$store.dispatch("plants/getAllInfo", {// info del dashboard general -> /calculator 
             department: linkdepto,
             city: linkcity
        });    
        this.$store.dispatch('admin/getInfo', city); //trae los nombres de departamenots de la planta
        this.$store.dispatch('admin/getReportsInfo');
        
       
    },
    updated(){
        // Guardar el depto actual 
        let city =this.$store.getters["admin/getName"];
        let depto =this.$store.getters["admin/getDep"];
        this.$store.dispatch("plants/setHistoryCity", city);
        this.$store.dispatch("plants/setHistoryDepto", depto);
       /* console.log(this.$store.getters["plants/getHistoryDepto"])
        console.log(this.$store.getters["plants/getHistoryCity"])
        console.log(city)
        console.log(depto) */
    },
    computed: {
        isLoading() {
            return this.$store.getters['plants/loading'];
        },
        depto() {
            return this.$store.getters['plants/data'];
        },
        bd() {
            return this.$store.getters['plants/bd'];
        },
        cityName() {
            return this.$store.getters["admin/getName"];
        },
        depName() {
            return this.$store.getters["admin/getDep"];
        },
        dep(){
            return this.$store.getters['admin/data'];
        },
        reportInfo(){
            return this.$store.getters['admin/report']
        },
        user() {            
            return this.$store.getters['userService/getIdentity'];
        },
         historyOption(){
                return this.$store.getters["csvplantas/getHistoryOption"]
         },
    },
    methods: {
           ...mapActions('csvplantas', ['setHistoryOptionCsv']),
        logout: function(){
            this.$router.push({ name: "login"});
            this.$store.dispatch("userService/logout");
        },
        hora: function(){
             let h = moment().format('HH:mm');

            if(h > '10:46'){ //a partir de esta hora se deben guardar la info el domingo.
                return 'yes'
            }else{
                return 'no'
            }
        },
          toQuery: function () {
            this.$router.push("/query").catch((err) => {});
         },
           
    },

}
</script>
<style scoped>
hr{
    border-color: white;
}
.blueText{
    color: #005cc3;
    font-family: 'FuturaPTHeavy';
}
.bg-gris{
    border-radius: 0;
}
.btn-toolbar{
    flex-wrap: nowrap !important;
}
button.logout{
    border-radius: 20px;
    border-color: #4d78e7;
    color: #4d78e7;
    text-transform: uppercase;
    font-size: 11px;
    padding: .5rem 1.5rem;
}
button.logout:hover{
    background-color: #3b63c9;
    border-color: #3b63c9;
    color: white;
}
button.logout:focus{
    outline: none;
}
.icon3{
    max-width: 4rem;
}
p.modalHeader{    
    color: #fd832d;
    text-transform: uppercase;
    font-family: 'FuturaPTDemi';
}
p.modalBody{
    font-size: 17px;
    font-weight: lighter;
    font-family: 'FuturaPTMedium';
    color: #838383;
}
.wrapper {
    display: grid;
    grid-template-columns: auto;
    grid-auto-rows: auto;
}
.one {
    grid-column: 1;
    grid-row: 4;
    font-family: 'FuturaPTMedium';
    background-color: #f3f3f3;
    color: #838383;
    border-color: #f3f3f3;  
}
.two {
    grid-column: 2;
    grid-row: 4;
    font-family: 'FuturaPTMedium';
    background-color: #fd832d;
    border-color: #fd832d;  
}
#modal-logout > .modal-dialog > .modal-content{
    border-radius: 24px;
}
.btnleft{
    border-radius: 0px;
    border-bottom-left-radius: 20px;
}
.btnright{
    border-radius: 0px;
    border-bottom-right-radius: 20px;
}
</style>